var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-toolbar',{attrs:{"hasChanges":_vm.hasChanges,"appliedFilters":_vm.appliedFilters,"allowFilters":false},on:{"search":_vm.search,"update":_vm.update,"clear":_vm.clear}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }